import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  searchUserText: '',
  user_Type: 'All',
  userAccountStatus: 'All',
  recordsPerPage: 10,
  pageNumber: 1,
  activeItem: '',
};

export const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState: INITIAL_STATE,
  reducers: {
    setSearchUserText: (state, action) => {
      state.searchUserText = action.payload;
    },
    setUser_Type: (state, action) => {
      state.user_Type = action.payload.value;
    },
    setUserAccountStatus: (state, action) => {
      state.userAccountStatus = action.payload.value;
    },
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },

    resetUserManagement: (state, action) => {
      state.searchUserText = INITIAL_STATE.searchUserText;
      state.user_Type = INITIAL_STATE.user_Type;
      state.userAccountStatus = INITIAL_STATE.userAccountStatus;
      state.recordsPerPage = INITIAL_STATE.recordsPerPage;
      state.pageNumber = INITIAL_STATE.pageNumber;
      state.activeItem = INITIAL_STATE.activeItem;
    },
  },
});

export const {
  setSearchUserText,
  setUser_Type,
  setUserAccountStatus,
  setRecordsPerPage,
  setPageNumber,
  setActiveItem,
  resetUserManagement,
} = userManagementSlice.actions;

export default userManagementSlice.reducer;
